import React from "react";
import { ActionsMenu } from "../../common/components/ActionsMenu";
import { ConditionalWrapper } from "../../common/components/ConditionalWrapper";
import { MENU_ACTIONS } from "../../common/components/modals/constants";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { RequiredRoles } from "../criteria/components/common/requiredRoles";
import { Download } from "../download/Download";
import { Searches } from "../searches/Searches";
import { ViewsActions } from "./ViewsActions";
import {
	additionalActionsType,
	additionalSearchType,
	criteriaElementsType,
	downloadType,
	viewsType,
} from "../../common/types/search/search";

interface SearchActionsProps {
	additionalAction?: additionalActionsType;
	additionalSearch?: additionalSearchType;
	criteria?: criteriaElementsType;
	download: downloadType;
	layoutSwitcher?: React.ReactNode;
	namespace: string;
	resultsAreLoaded: boolean;
	resultsPreview: React.ReactNode;
	searchesEnabled: boolean;
	views: viewsType;
}

export function SearchActions({
	namespace,
	resultsPreview,
	resultsAreLoaded,
	searchesEnabled,
	download,
	views,
	additionalAction,
	additionalSearch,
	layoutSwitcher,
}: SearchActionsProps) {
	const { downloadEnabled, downloadRoles } = download;
	const { isMobile } = useAccessWindowSize();
	const showMenu = !additionalSearch && isMobile;

	const getAdditionalActionAndDownloads = () => {
		if (!resultsAreLoaded || (!additionalAction && !downloadEnabled)) {
			return null;
		}

		return (
			<div className="actions__action">
				<div className="btn-group-divided">
					{additionalAction}
					{resultsAreLoaded && downloadEnabled && (
						<Download
							namespace={namespace}
							downloadRoles={RequiredRoles.showFor(downloadRoles)}
						/>
					)}
				</div>
			</div>
		);
	};

	return (
		<ConditionalWrapper
			condition={showMenu}
			wrapper={(children) => (
				<ActionsMenu id={MENU_ACTIONS}>{children}</ActionsMenu>
			)}
		>
			<div className="search-actions">
				{searchesEnabled && (
					<div className="actions__action">
						<Searches
							namespace={namespace}
							label={"Current search"}
						/>

						{resultsAreLoaded && (
							<div className="flex info--text info--results">
								<p>Data search</p>
								{resultsPreview}
							</div>
						)}
					</div>
				)}

				{getAdditionalActionAndDownloads()}

				<ViewsActions
					namespace={namespace}
					resultsAreLoaded={resultsAreLoaded}
					views={views}
				/>

				{layoutSwitcher}
				{additionalSearch}
			</div>
		</ConditionalWrapper>
	);
}
